<script setup>
import {object, string} from "yup";
import {computed, ref, toRef} from "vue";
import validator from "../../components/Validator";

const props = defineProps({
  modelValue: {
    type: Object,
  }
})

const modelValue = toRef(props, 'modelValue');
modelValue.value.suffix = modelValue.value.suffix || '';

const schema = object().shape({
  streetname: string().required().label('Straatnaam'),
  city: string().required().label('Stad'),
  zipcode: string().required().label('Postcode'),
  housenumber: string().required().label('Huisnummer'),
  suffix: string().label('Toevoeging'),
});

function checkAddress() {
  if (modelValue.value.zipcode && modelValue.value.housenumber) {
    getAddress(modelValue.value.zipcode, modelValue.value.housenumber, modelValue.value.suffix);
  }
}

const autoCompletedAddress = computed(() => {
  if (modelValue.value.zipcode && modelValue.value.streetname) {
    return `${modelValue.value.zipcode} - ${modelValue.value.streetname}  ${modelValue.value.housenumber}${modelValue.value.suffix ? '-'+modelValue.value.suffix : ''} - ${modelValue.value.city}`;
  }

  return '';
})

const errors = ref({});
const validate = validator(schema, modelValue, errors)

const correctAddress = ref(false);

function getAddress(zipcode, number, suffix) {
  const formData = new FormData();
  formData.append('action', 'get_address');
  formData.append('postcode', zipcode);
  formData.append('number', number);
  formData.append('suffix', suffix);

  fetch(window.WPURLS.ajaxurl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Cache-Control': 'no-cache',
    },
    body: new URLSearchParams(formData),
  })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (!data.success) {
          throw new Error(data.data);
        }
        if (data.data.street) {
          props.modelValue.streetname = data.data.street;
        }
        if (data.data.city) {
          props.modelValue.city = data.data.city;
        }
      })
      .catch((error) => {
        console.log('Error:', error);
        correctAddress.value = true;
      });
}
</script>

<template>
  <div class="entry__divider">
    <div class="entry__field entry__field--xs">
      <label for="zipcode">Postcode<span class="required-indicator">*</span></label>
      <input id="zipcode" data-address-role="postcode" type='text' v-model="modelValue.zipcode" @blur="validate('zipcode'); checkAddress();" placeholder="1234 AB" required/>
      <p class="input-error" v-if="!!errors.zipcode">
        {{ errors.zipcode }}
      </p>
    </div>

    <div class="entry__field entry__field--xs">
      <label for="housenumber">Huisnummer<span class="required-indicator">*</span></label>
      <input id="housenumber" data-address-role="number" type='number' v-model="modelValue.housenumber" min="1" placeholder="17"  required  @blur="validate('housenumber'); checkAddress();"/>
      <p class="input-error" v-if="!!errors.housenumber">
        {{ errors.housenumber }}
      </p>
    </div>
    <div class="entry__field entry__field--xs">
      <label for="suffix">Toevoeging</label>
      <input id="suffix" data-address-role="suffix" type='text' v-model="modelValue.suffix" placeholder="Bis"  @blur="validate('suffix'); checkAddress();" />
    </div>
  </div>

  <div class="entry__divider entry__field entry__address" v-if="!correctAddress">
    <div>
      <input type="text" v-model="autoCompletedAddress" placeholder="Vul postcode en huisnummer in" readonly>
      <div class="entry__correctaddress" v-if="autoCompletedAddress">
        <button @click="correctAddress = true">Kloppen deze gegevens niet?</button>
      </div>
    </div>
  </div>

  <div class="entry__divider" v-if="correctAddress">
    <div class="entry__field entry__field--last entry__field--md">
      <label for="streetname">Straatnaam<span class="required-indicator">*</span></label>
      <input id="streetname" data-address-role="street" type='text' v-model="modelValue.streetname" @blur="validate('streetname')" placeholder="Straatnaam"  aria-label='Straatnaam' required />
      <p class="input-error" v-if="!!errors.streetname">
        {{ errors.streetname }}
      </p>
    </div>

    <div class="entry__field entry__field--last entry__field--sm">
      <label for="city">Plaatsnaam<span class="required-indicator">*</span></label>
      <input id="city" data-address-role="city" type='text' v-model="modelValue.city" @blur="validate('city')" placeholder="Plaatsnaam"  aria-label='Plaatsnaam' required />
      <p class="input-error" v-if="!!errors.city">
        {{ errors.city }}
      </p>
    </div>
  </div>
</template>

<style scoped>

</style>